// components/features/job-offers/JobOfferRow.tsx
import { JobOffer } from "../../../types/features/JobOffer";
import TableRow from "../../ui/TableRow";

interface JobOfferRowProps {
  jobOffer: JobOffer;
  onAction: (jobOffer: JobOffer) => void;
  onSelect?: (jobOffer: JobOffer, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function JobOfferRow({
  jobOffer,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false,
}: JobOfferRowProps) {
  const getContractTypeLabel = () => {
    const types = {
      cdi: { label: "CDI", className: "bg-blue-100 text-blue-700" },
      cdd: { label: "CDD", className: "bg-yellow-100 text-yellow-700" },
      freelance: { label: "Freelance", className: "bg-purple-100 text-purple-700" },
      internship: { label: "Stage", className: "bg-green-100 text-green-700" },
    };
    return types[jobOffer.contract_type];
  };

  const contractType = getContractTypeLabel();
  const isExpired = new Date(jobOffer.deadline) < new Date();
  const isDeadlineSoon = !isExpired && new Date(jobOffer.deadline) < new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <TableRow
      item={jobOffer}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">{jobOffer.title}</span>
          <span className="text-xs text-gray-500">{jobOffer.location}</span>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${contractType.className}`}>
          {contractType.label}
        </span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className="text-gray-600 text-sm">{jobOffer.salary || "À négocier"}</span>
      </td>

      <td className="hidden lg:table-cell py-3 px-4">
        <div>
          <span
            className={`text-sm ${isExpired ? "text-red-600" : isDeadlineSoon ? "text-orange-600" : "text-gray-600"}`}
          >
            {formatDate(jobOffer.deadline)}
          </span>
          {isExpired && <span className="ml-2 text-xs text-red-600">(Expirée)</span>}
        </div>
      </td>

      <td className="hidden xl:table-cell py-3 px-4">
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            jobOffer.is_visible ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"
          }`}
        >
          {jobOffer.is_visible ? "Visible" : "Masqué"}
        </span>
      </td>
    </TableRow>
  );
}
